import ContactPhoneNumber from './ContactPhoneNumber';
import Timer from './Timer';
import { Box } from '@coolblue-development/freddy';

const ContactContainer = (): JSX.Element => {
  return (
    <Box>
      <Timer />
      <ContactPhoneNumber />
    </Box>
  );
};

export default ContactContainer;
